import bounceAttnGrabberImage from "./presetImages/bounce-attn-grabber.png";
import flashImage from "./presetImages/flash.png";
import pulseImage from "./presetImages/pulse.png";
import stretchImage from "./presetImages/stretch.png";
import shakeImage from "./presetImages/shake.png";
import tadaImage from "./presetImages/tada.png";
import wobbleImage from "./presetImages/wobble.png";
import heartbeatImage from "./presetImages/heartbeat.png";
import backImage from "./presetImages/back.png";
import bounceTransitionalImage from "./presetImages/bounce-transitional.png";
import fadeImage from "./presetImages/fade.png";
import flipImage from "./presetImages/flip.png";
import rotateImage from "./presetImages/rotate.png";
import zoomImage from "./presetImages/zoom.png";
import slideImage from "./presetImages/slide.png";
import typeInImage from "./presetImages/typeIn.png";
import riseImage from "./presetImages/rise.png";
import noneImage from "./presetImages/none.png";

// Feature flag for Typewriter animation (renderer doesn't support it yet)
const isTypewriterAnimationEnabled =
  process.env.REACT_APP_TYPEWRITER_ANIMATION_ENABLED === "true";

// Feature flag for Rise animation (renderer doesn't support it yet)
const isRiseAnimationEnabled =
  process.env.REACT_APP_RISE_ANIMATION_ENABLED === "true";

// Feature flag for Random letter animation (renderer doesn't support it yet)
const isRandomAnimationEnabled =
  process.env.REACT_APP_RANDOM_ANIMATION_ENABLED === "true";

/**
 * Helper to conditionally include items in arrays based on feature flags.
 * Returns the items array if enabled, otherwise returns empty array.
 * @param {boolean} enabled - Whether the feature is enabled
 * @param {Array|any} items - Items to include (will be wrapped in array if not already)
 * @returns {Array} - Items array if enabled, empty array otherwise
 */
const conditionalItems = (enabled, items) =>
  enabled ? (Array.isArray(items) ? items : [items]) : [];

// Typewriter preset - only shown for letter animations
export const typewriterPreset = {
  name: "typeIn",
  label: "Type In",
  image: typeInImage
};

const baseAnimationPresets = [
  { name: "none", label: "None", image: noneImage },
  { name: "slide", label: "Slide", image: slideImage },
  ...conditionalItems(isRiseAnimationEnabled, {
    name: "rise",
    label: "Rise",
    image: riseImage
  }),
  { name: "fade", label: "Fade", image: fadeImage },
  { name: "bounce", label: "Bounce", image: bounceTransitionalImage },
  { name: "zoom", label: "Zoom", image: zoomImage },
  { name: "back", label: "Back", image: backImage },
  { name: "rotate", label: "Rotate", image: rotateImage },
  { name: "flip", label: "Flip", image: flipImage },
  { name: "boing", label: "Boing", image: bounceAttnGrabberImage },
  { name: "shake", label: "Shake", image: shakeImage },
  { name: "flash", label: "Flash", image: flashImage },
  { name: "pulse", label: "Pulse", image: pulseImage },
  { name: "rubberBand", label: "stretch", image: stretchImage },
  { name: "tada", label: "Tada", image: tadaImage },
  { name: "wobble", label: "Wobble", image: wobbleImage },
  { name: "heartBeat", label: "Heartbeat", image: heartbeatImage }
];

export const animationPresets = baseAnimationPresets;

// Check if typewriter animation is enabled (for use in AnimationsTab)
export const isTypewriterEnabled = isTypewriterAnimationEnabled;

// Check if random animation is enabled (for use in AnimationsTab)
export const isRandomEnabled = isRandomAnimationEnabled;

export const transitionPresets = [
  "bounce",
  "back",
  "fade",
  "flip",
  "rotate",
  "zoom",
  "slide",
  ...conditionalItems(isRiseAnimationEnabled, "rise"),
  "shake"
];

export const mandatoryDirectionPresets = [
  "back",
  "slide",
  ...conditionalItems(isRiseAnimationEnabled, "rise"),
  "flip",
  "shake",
  "fade",
  "bounce",
  "zoom"
];

export const axisDirectionPresets = ["flip", "shake"];

// Presets that support "center" direction
export const centerDirectionPresets = ["fade", "bounce", "zoom"];

// Presets that support random direction (must have both "up" AND "down" directions)
// Random direction uses only up/down for visual aesthetics
export const randomDirectionPresets = [
  "slide",
  ...conditionalItems(isRiseAnimationEnabled, "rise"),
  "fade",
  "bounce",
  "zoom",
  "back"
];

// Random direction pool - only up/down for visual consistency
export const RANDOM_DIRECTION_POOL = ["up", "down"];

// mutiple css animation presets - these can be used for start and end animations
export const multipleTransitionPresets = [
  "bounce",
  "back",
  "fade",
  "flip",
  "rotate",
  "zoom",
  "slide",
  ...conditionalItems(isRiseAnimationEnabled, "rise"),
  ...conditionalItems(isTypewriterAnimationEnabled, "typeIn")
];

// single css animation presets - these can be used for the middle animation
export const singleTransitionPresets = [
  "shake",
  "flash",
  "pulse",
  "rubberBand",
  "tada",
  "wobble",
  "heartBeat"
];
